import React, { useEffect, useState } from "react";
import Revenue from "../../data/data.json";
import CostSaving from "../../data/CostSaving.json";
import TotalValue from '../../data/TotalData.json'
import ImproveMarginRevenue from "../../data/ImproveMarginRevenue.json";
import ImproveMarginCostSaving from "../../data/ImproveMarginCostSaving.json";
import ImproveMarginOverHead from "../../data/ImproveMarginOverHead.json";
import ImproveMarginOther from "../../data/ImproveMarginOther.json";

import "./DetailsView.scss";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

const DetailsSummary = ({ data }) => {
  const [dataItem, setDataItem] = useState(Revenue);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false); // State to control visibility of extra items
  const navigate = useNavigate();


console.log(data.label)
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get('name');
  
  console.log(name)
  console.log(data.label)

  // const filteredData = TotalValue && TotalValue.filter(item => 
  //   item.PrimaryType === `${name}` && item.SecondaryType === `${data.label}`
  // );

  // console.log(filteredData)
  // const moduleSums = filteredData && filteredData.reduce((acc, item) => {
  //   if (!acc[item.ModuleName]) {
  //     acc[item.ModuleName] = { ...item, TotalValue: 0, recommendations: 0 };
  //   }
  //   acc[item.ModuleName].TotalValue += item.TotalValue;
  //   acc[item.ModuleName].recommendations += item.Recommendations ? item.Recommendations.split('.').length - 1 : 0;
  //   return acc;
  // }, {});

  // console.log(moduleSums)
  
  // // Transform the grouped object into an array
  // const transformedData = Object.values(moduleSums).map(item => ({
  //   ModuleName: item.ModuleName,
  //   headerText: "",
  //   KeyInsights: item.KeyInsights,
  //   TotalvalueCreation: `$ ${item.TotalValue.toFixed(3)}`,
  //   recommendations: item.recommendations.toString()
  // }));
  
  // console.log(transformedData);

  const filteredData = Array.isArray(TotalValue) 
  ? TotalValue.filter(item => 
      item.PrimaryType === name && item.SecondaryType === data.label
    ) 
  : [];

console.log("Filtered Data:", filteredData);

const moduleSums = filteredData.reduce((acc, item) => {
  if (!acc[item.ModuleName]) {
    acc[item.ModuleName] = { 
      ModuleName: item.ModuleName, 
      KeyInsights: item.KeyFunctions, 
      TotalValue: 0, 
      recommendations: 0 
    };
  }

  // Sum TotalValue correctly
  acc[item.ModuleName].TotalValue += Number(item.TotalValue) || 0;

  // Count recommendations correctly (each entry contributes one recommendation)
  if (item.Recommendations && typeof item.Recommendations === "string") {
    acc[item.ModuleName].recommendations += 1; 
  }

  return acc;
}, {});

// Convert grouped object into an array and format TotalValue
const transformedData = Object.values(moduleSums).map(item => ({
  ModuleName: item.ModuleName,
  headerText: "",
  KeyInsights: item.KeyInsights,
  TotalvalueCreation: `$ ${item.TotalValue.toFixed(1)}`,
  recommendations: item.recommendations.toString()
}))
.sort((a, b) => 
  parseFloat(b.TotalvalueCreation.replace("$ ", "")) - parseFloat(a.TotalvalueCreation.replace("$ ", ""))
);


const visibleItems = showAll ? transformedData : transformedData.slice(0, 5); // Show only 5 initially
console.log("visibleItems")
console.log(visibleItems)

  useEffect(()=>{
    if(name ==="Improve Operating Margins" && data.label === "Revenue Growth"){
      setDataItem(ImproveMarginRevenue)
    }
    else if(name ==="Improve Operating Margins" && data.label === "Cost Savings"){
      setDataItem(ImproveMarginCostSaving)
    }
    else if(name ==="Improve Operating Margins" && data.label === "Overhead Control​"){
      setDataItem(ImproveMarginOverHead)
    }
    else if(name ==="Improve Operating Margins" && data.label === "Other Initiatives​"){
      setDataItem(ImproveMarginOther)

    }
    else{
      setDataItem([])

    }
    
  },[data,TotalValue])

  return (
   <>
   {visibleItems && visibleItems.length !==0 && (
     <div className="shadow border-none">
     <div style={{ display: "grid", gap: "10px" }}>
       {loading ? (
         <Skeleton count={5} style={{width:"100%"}} height={200} />
       ) : (
         <>
           {visibleItems && visibleItems.map((item, index) => (
             <div
               key={index}
               className="w-auto p-4 border rounded-2xl to-pink-50 via-pink-50 from-white bgcolornew"
             >
               <div className="justify-end items-start">
                 <div className="w-3/3">
                 <div style={{justifyContent:"space-between"}} className="flex">
                   <h2 className="text-lg font-bold text-blue-600">
                     {item.ModuleName}
                   </h2>

                   <span style={{display:"grid",textAlign:"center"}}>
                     <span style={{color:"#F42EBF"}} className="text-xl font-bold text-blue-600">
                       {item.TotalvalueCreation} Mn
                     </span>
                     <span className="text-sm text-gray-500">Value Creation</span>
                   </span>
                 </div>
                  
                   <p style={{width:"70%"}} className="mt-1 text-sm text-gray-700">{item.KeyInsights}</p>
                  
                 </div>

                 <div style={{justifyContent:"space-between",alignContent:"center",alignItems:"center"}} className="flex">
                 <a
                     href={`/summary?name=${item.ModuleName}&&details=${name}&&node=${data.label}`}
                     className="mt-2 inline-block text-sm font-medium text-blue-600 underline"
                   >
                     Review
                   </a>

                   <span style={{display:"flex",textAlign:"center",gap:"10px",alignContent:"center",alignItems:'center'}}>
                     <span  className="text-xl font-bold text-blue-600">
                       {item.recommendations}
                     </span>
                     <span className="text-sm text-gray-500">Recommendations</span>
                   </span>
                 </div>
                 {/* <div className="w-1/3">
                 
                   <span className="mt-2 text-sm text-gray-500">
                     <span className="font-medium text-black">5</span>{" "}
                     Recommendations
                   </span>
                 </div> */}
               </div>
             </div>
           ))}
           {/* Read More button */}
           {!showAll && transformedData.length > 5 && (
             <button
               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg"
               onClick={() => setShowAll(true)}
             >
                More
             </button>
           )}
         </>
       )}
     </div>
   </div>
   )}

   {visibleItems && visibleItems.length === 0 && (
    <span style={{padding:"2rem",overflow:"hidden",height:"300px",display:"block",textAlign:"center",alignContent:"center",alignItems:"center"}}>
      No Data available for <b>{name} </b>with <b>{data.label}</b>
    </span>
   )}
   </>
  );
};

export default DetailsSummary;
